export default __webpack_public_path__ + "static/Gel-Pillow 2-4b4b4d3d035ade5c84a6fa40cfb29909.png";